require("!!./node_modules/script-loader/addScript.js")(require("!!./node_modules/script-loader/node_modules/raw-loader/index.js!./src/js/jquery.splitter.js")+"\n\n// SCRIPT-LOADER FOOTER\n//# sourceURL=script://./src/js/jquery.splitter.js")


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./src/js/jquery.splitter.js
// module id = 175
// module chunks = 0